import OnlineShowcaseBlock from './component';

export default OnlineShowcaseBlock;
